/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InclusaoBeneficiarioCancelarAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  BUTTON_CONFIRMAR = 'button-confirmar',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH_0 = 'fetch-0',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FORM_CANCELAR_SOLICITACAO = 'form-cancelar-solicitacao',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
  PANEL_CANCELAR_SOLICITACAO = 'panel-cancelar-solicitacao',
  TEXT_0 = 'text-0',
  TEXT_AREA_OBSERVACAO = 'text-area-observacao',
}
export { InclusaoBeneficiarioCancelarAliases };
